import styled from "styled-components";

export const TransferTip = styled.div`
  margin: -24px -24px 24px -24px;
  width: calc(100% + 48px);
  height: 32px;
  background: rgba(19, 203, 117, 0.1);
  text-align: center;
  line-height: 32px;
  span {
    margin: 0 5px;
    color: var(--main-color);
  }
`;
